import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../services/api'

export default function Themes() {
  const [insights, setInsights] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false
    api
      .get('/api/v1/insights/themes')
      .then((data) => {
        if (!cancelled) setInsights(data)
      })
      .catch((err) => {
        if (!cancelled) setError(err.message)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <div className="max-w-3xl mx-auto space-y-6">
      <div>
        <Link to="/knowledge" className="text-xs font-medium text-slate-500 hover:text-slate-700">
          ← Knowledge
        </Link>
        <h2 className="mt-2 text-2xl font-semibold tracking-tight text-slate-900">
          Cross-cutting themes
        </h2>
        <p className="mt-1 text-sm text-slate-500">
          Common threads and opportunities across every initiative.
        </p>
      </div>

      {loading && <p className="text-sm text-slate-500">Loading…</p>}
      {error && <p className="text-sm text-rose-600">{error}</p>}

      {!loading && !error && insights.length === 0 && (
        <div className="rounded-xl border border-dashed border-slate-300 bg-white p-10 text-center">
          <p className="text-sm text-slate-500">No cross-cutting insights generated yet.</p>
          <p className="mt-2 text-xs text-slate-400">
            Ask an admin to trigger <code className="px-1.5 py-0.5 bg-slate-100 rounded">POST /api/v1/insights</code>.
          </p>
        </div>
      )}

      {insights.map((insight) => (
        <div
          key={insight.id}
          className="rounded-xl border border-accent-100 bg-accent-50/50 p-6"
        >
          <div className="text-sm text-slate-700 whitespace-pre-wrap leading-relaxed">
            {insight.content}
          </div>
          <div className="mt-3 text-xs text-slate-400">
            Generated {new Date(insight.generated_at).toLocaleString()}
          </div>
        </div>
      ))}
    </div>
  )
}
